import api from './api';

export interface Chapter {
  id: number;
  title: string;
  description?: string | null;
  order: number;
  course_id: number;
  created_at?: string | null;
  updated_at?: string | null;
  video_count?: number;
  task_count?: number;
}

export const chapterService = {
  getCourseChapters: async (courseId: number) => {
    const response = await api.get<{ chapters: Chapter[] }>(`/chapters/course/${courseId}`);
    return response.data.chapters;
  },

  getChapter: async (chapterId: number) => {
    const response = await api.get<{ chapter: Chapter }>(`/chapters/${chapterId}`);
    return response.data.chapter;
  },

  create: async (payload: Partial<Chapter>) => {
    const response = await api.post<{ message: string; chapter: Chapter }>('/chapters', payload);
    return response.data.chapter;
  },

  update: async (id: number, payload: Partial<Chapter>) => {
    const response = await api.put<{ message: string; chapter: Chapter }>(`/chapters/${id}`, payload);
    return response.data.chapter;
  },

  delete: async (id: number) => {
    const response = await api.delete<{ message: string }>(`/chapters/${id}`);
    return response.data;
  },
};



